// Import Libraries
import React from 'react';
// Import JS Modules
import QuantityPricingTools         from './quantity-pricing-tools';
// Import JSX Modules
import ProductFlagsBase             from '../_utils/product-flags';

// -----------------------------------------------------------
export default props => {
  const wasPrice = (props.was_price || []).reduce((memo, wp) => {
    if (wp.quantity <= props.copies) {
      return wp;
    }

    return memo;
  }, {});

  const price = new QuantityPricingTools({prices: props.prices}).getUnitPriceForQuantity(props.copies);

  return (
    <ProductFlagsBase {...props}
                      price={price}
                      was_price={wasPrice} />
  );
};
